import React from "react"
import PropTypes from "prop-types"

const VehicleIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 31 14">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-21.000000, -136.000000)">
      <g transform="translate(22.000000, 137.000000)" stroke="#979797" strokeWidth="1.98">
        <path d="M3.95454545,9.5395752 C1.555335,9.36755053 0.32620522,9.0575625 0.267156103,8.60961109 C0.178582427,7.93768399 -0.657820099,5.39872865 1.17243118,4.81786858 C2.34456701,4.47175229 4.68851304,3.09482473 8.1283955,3.1358972 C11.568278,3.17696967 10.468271,-0.366645911 18.4867938,0.0311570884 C26.5053166,0.428960088 27.8151976,3.10041346 28.4978987,4.55 C29.1805999,5.99958654 29.0550662,8.02475146 28.7764825,8.31718128 C28.59076,8.51213449 27.498662,8.75067271 25.5001887,9.03279595"></path>
        <ellipse id="Oval-3" cx="5.93181818" cy="9.75" rx="2.30545455" ry="2.26"></ellipse>
        <ellipse id="Oval-3-Copy" cx="23.0681818" cy="9.75" rx="2.30545455" ry="2.26"></ellipse>
        <path d="M7.90909091,9.1 L20.794994,9.1"></path>
      </g>
    </g>
  </svg>
)

VehicleIcon.propTypes = {
  style: PropTypes.object
}

export default VehicleIcon



// WEBPACK FOOTER //
// ./src/components/icons/vehicle-icon.jsx